import { Mitarbeiter } from '@/domain/navigation/benachrichtigungen/types/Benachrichtungen';
import dayjs from 'dayjs';

export class Personalfragebogen {
  constructor({
    id,
    erstellungsDatum,
    mitarbeiter,
  }: {
    id: string;
    erstellungsDatum: dayjs.Dayjs;
    mitarbeiter: Mitarbeiter;
  }) {
    this.id = id;
    this.erstellungsDatum = erstellungsDatum;
    this.mitarbeiter = mitarbeiter;
  }

  id: string;
  erstellungsDatum: dayjs.Dayjs;
  mitarbeiter: Mitarbeiter;
}
